export default __webpack_public_path__ + "static/media/health-check-up.ec833489.svg";